import type { ReactNode } from "react";

import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import type { IDropDownItem } from "@similarweb/ui-components";
import { Autocomplete, EllipsisDropdownItem } from "@similarweb/ui-components";

import type { IAutocompleteStyledProps } from "pro-features/components/AutocompleteWebsites/types";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const AutocompleteStyled = styled(Autocomplete)<IAutocompleteStyledProps>`
    width: 360px;
    .input-container {
        border-radius: 3px 3px 0 0;
        height: 56px;
        padding-bottom: 8px;
        padding-top: 8px;
    }
    .input-container:after {
        content: "";
        width: 90%;
        position: absolute;
        bottom: 0;
        height: 1px;
        background-color: ${colorsPalettes.blue[400]};
    }
`;

export const DropDownItem = styled(EllipsisDropdownItem)<
    IDropDownItem & { iconName: string; iconSize: string; children?: ReactNode }
>`
    ${css`
        svg {
            width: 100%;
            height: 100%;
        }
    `}
`;

export const CampaignsDropDownItemContent = styled(FlexRow)`
    align-items: center;
`;

export const ItemText = styled.span`
    margin-left: 8px;
`;

export const NoResultsWrapper = styled.div`
    padding: 44px 30px;
    text-align: center;
    background-color: ${colorsPalettes.carbon[0]};
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
`;

const BaseWrapper = styled.div`
    position: absolute;
    left: 312px;
    z-index: 10;
    top: 50px;
`;

export const WarningMessageWrapper = styled(BaseWrapper)`
    max-width: 312px;
    max-height: 170px;
    border-radius: 4px;
    background-color: ${colorsPalettes.carbon[0]};
    box-shadow: 1px 1px 6px rgb(0, 0, 0, 0.24);
`;
